import type { ModuleId, TenantBranding } from '@buildex/module-contract';
import type { AdminTenant, CreateTenantParams } from './types';

/**
 * Мок-API админки. После Swagger заменяется на apiClient из core:
 * GET/POST /api/admin/tenants, PUT /api/admin/tenants/:id/branding и т.д.
 */

function delay(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

const MOCK_TENANTS: AdminTenant[] = [
  {
    id: 'ten-0001',
    name: 'NAK',
    slug: 'nak',
    active: true,
    modules: ['pricing', 'dco'],
    branding: { logoUrl: '', primaryColor: '#0b7285', colorScheme: 'light', radius: 'md' },
    users: [
      { id: 'u-1', email: 'aliya@nak.kz', name: 'Алия', roleId: 'r-admin', status: 'active' },
      { id: 'u-2', email: 'daniyar@nak.kz', name: 'Данияр', roleId: 'r-sales', status: 'active' },
    ],
    roles: [
      { id: 'r-admin', name: 'Администратор', permissions: ['*'] },
      { id: 'r-sales', name: 'Менеджер продаж', permissions: ['dco.view', 'dco.export'] },
    ],
  },
  {
    id: 'ten-0002',
    name: 'BI Group',
    slug: 'bi.group',
    active: true,
    modules: ['dco', 'sco'],
    branding: { logoUrl: '', primaryColor: '#5f3dc4', colorScheme: 'light', radius: 'lg' },
    users: [
      { id: 'u-3', email: 'admin@bi.group', name: 'Админ BI', roleId: 'r-admin', status: 'active' },
      { id: 'u-4', email: 'new@bi.group', name: '—', roleId: 'r-sales', status: 'invited' },
    ],
    roles: [
      { id: 'r-admin', name: 'Администратор', permissions: ['*'] },
      { id: 'r-sales', name: 'Коммерческий отдел', permissions: ['dco.view', 'dco.edit', 'sco.view'] },
    ],
  },
  {
    id: 'ten-0003',
    name: 'Demo',
    slug: 'demo',
    active: false,
    modules: [],
    branding: { logoUrl: '', primaryColor: '#1971c2', colorScheme: 'light', radius: 'md' },
    users: [],
    roles: [{ id: 'r-admin', name: 'Администратор', permissions: ['*'] }],
  },
];

export async function fetchTenants(): Promise<AdminTenant[]> {
  await delay(400);
  return structuredClone(MOCK_TENANTS);
}

export async function createTenant(params: CreateTenantParams): Promise<AdminTenant> {
  await delay(400);
  return {
    id: `ten-${Date.now()}`,
    name: params.name,
    slug: params.slug,
    active: true,
    modules: [],
    branding: { logoUrl: '', primaryColor: params.primaryColor, colorScheme: 'light', radius: 'md' },
    users: [],
    roles: [{ id: 'r-admin', name: 'Администратор', permissions: ['*'] }],
  };
}

export async function setTenantActive(
  tenantId: string,
  active: boolean,
): Promise<{ tenantId: string; active: boolean }> {
  await delay(250);
  return { tenantId, active };
}

export async function setTenantModule(
  tenantId: string,
  moduleId: ModuleId,
  enabled: boolean,
): Promise<{ tenantId: string; moduleId: ModuleId; enabled: boolean }> {
  await delay(250);
  return { tenantId, moduleId, enabled };
}

export async function saveTenantBranding(
  tenantId: string,
  branding: TenantBranding,
): Promise<{ tenantId: string; branding: TenantBranding }> {
  await delay(450);
  return { tenantId, branding: structuredClone(branding) };
}
